import * as Sentry from '@sentry/browser';

import { version } from '../../../../../package.json';


export default class SentryAdapter {
  init() {
    
    const IGNORED_ERRORS = [
      '401 Unauthorized',
      'Request failed with status code 401',
      '422 Unprocessable Entity',
      'Request failed with status code 422',
      'Request failed with status code 404',
    ];

    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      environment: process.env.REACT_APP_SENTRY_ENV,
      release: version,
      ignoreErrors: IGNORED_ERRORS,
      tracesSampleRate: 0.1,
    });
  }

  captureException(transactionName, severityLevel, error, details) {
    Sentry.withScope((scope) => {
      scope.setLevel(severityLevel);
      scope.setTransactionName(transactionName);
      if (details) {
        scope.setExtra('Error Details', details);
      }
      Sentry.captureException(error);
    });
  }

  captureLog(message, severityLevel, details) {
    Sentry.withScope((scope) => {
      scope.setLevel(severityLevel);
      scope.setTransactionName(message);
      if (details) {
        scope.setExtra('Details', details);
      }
      scope.setFingerprint([message, severityLevel]);
      Sentry.captureMessage(message);
    });
  }

  captureUIException(error, { componentStack }) {
    Sentry.withScope((scope) => {
      const errorBoundaryError = new Error(error.message);
      errorBoundaryError.name = `React ErrorBoundary ${errorBoundaryError.name}`;
      errorBoundaryError.stack = componentStack;

      scope.setTag('Origin', 'ErrorBoundary');
      scope.setExtra('Cause', errorBoundaryError);
      scope.setExtra('stack', error.stack);
      scope.setExtra('Componentstack', componentStack);
      scope.setExtra('Name', error.name);
      scope.setExtra('ErrorMessage', error.message);
      Sentry.configureScope((scope) =>
        scope.setTransactionName('Capturado com Error Boundary')
      );
      const eventId = Sentry.captureException(error, {
        contexts: { react: { componentStack } },
      });
      scope.setExtra('eventId', eventId);
    });
  }
}



// WEBPACK FOOTER //
// ./src/utils/errorLogger/adapters/Sentry/index.js